/**
 * Scroll smoothly to a section by id, robust to layout shifts caused by
 * async-loading images (gallery, courses…) that would otherwise abort the
 * native smooth-scroll halfway.
 */
export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;

  const navOffset = window.innerWidth >= 768 ? 80 : 56;

  const compute = () =>
    el.getBoundingClientRect().top + window.scrollY - navOffset;

  // Instant jump first so we always land
  const initialTarget = compute();
  window.scrollTo({ top: initialTarget, behavior: "auto" });

  // Re-snap after images settle (in case heights changed)
  let attempts = 0;
  const reSnap = () => {
    attempts += 1;
    const target = compute();
    if (Math.abs(window.scrollY - target) > 2) {
      window.scrollTo({ top: target, behavior: "auto" });
    }
    if (attempts < 4) {
      setTimeout(reSnap, 120);
    }
  };
  setTimeout(reSnap, 120);
}
